import { STATUSPAGE } from '@repo/ui';
import { HandleSummaryReportByGroup } from 'domain/usecases';
import { notifyError } from 'presentation/app/components/notify';
import { useService } from 'presentation/app/hooks/useService';
import {
  clearSummaryReportByGroup,
  loadSummaryReportByGroup,
} from 'presentation/config/store/reports/summary-report-by-group';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

export const useSummaryReportByGroup = () => {
  // Hooks
  const { reportService } = useService();
  const dispatch = useDispatch();

  //States
  const [loading, setLoading] = useState<STATUSPAGE>(STATUSPAGE.DONE);
  const [selectedSubmitBtn, setSelectedSubmitBtn] = useState<string>();
  const [hasFetchedData, setHasFetchedData] = useState(false);

  // Methods
  const requestHandleSummaryReportByGroup = useCallback(
    (params: HandleSummaryReportByGroup.Params) => {
      setLoading(STATUSPAGE.LOADING);
      reportService
        .handleSummaryReportByGroup(params)
        .then((res: HandleSummaryReportByGroup.Result) => {
          let blob = new Blob([JSON.stringify(res)], {
            type: `application/${params?.type === '0' ? 'pdf' : 'vnd.openxmlformats-officedocument.spreadsheetml.sheet'}`,
          });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          window.open(link.href, '_blank');
        })
        .catch((err) => {
          notifyError(err.message || 'Erro ao gerar relatório.');
        })
        .finally(() => {
          setLoading(STATUSPAGE.DONE);
        });
    },
    [],
  );

  const requestHandleSummaryReportByGroupJson = useCallback(
    (params: HandleSummaryReportByGroup.Params) => {
      setLoading(STATUSPAGE.LOADING);
      reportService
        .handleSummaryReportByGroup(params)
        .then((res: HandleSummaryReportByGroup.Result) => {
          dispatch(loadSummaryReportByGroup(res));
        })
        .catch((err) => {
          notifyError(err.message);
          dispatch(clearSummaryReportByGroup(err));
        })
        .finally(() => {
          setLoading(STATUSPAGE.DONE);
          setHasFetchedData(true);
        });
    },
    [],
  );

  return {
    // States
    loading,
    hasFetchedData,
    selectedSubmitBtn,
    // Methods
    setLoading,
    setSelectedSubmitBtn,
    requestHandleSummaryReportByGroup,
    requestHandleSummaryReportByGroupJson,
  };
};
